import { ReduxAction } from '../../types/reducers'
import { Languages } from '../../utility/Languages'

export enum GRAPHIC_ACTIONS {
    SET_CURRENT_LANGUAGE = 'graphicActions/setCurrentLanguage',
}

export const setCurrentLanguage: ReduxAction<Languages, GRAPHIC_ACTIONS> = (lang: Languages) => {
    return {
        type: GRAPHIC_ACTIONS.SET_CURRENT_LANGUAGE,
        payload: lang,
    }
}
